import React from "react";
import {toast, Toaster} from 'react-hot-toast';
import { Button } from "takeat-design-system-ui-kit";
const ToClipboard = ({ data , text ,color, disabled}) => {
  const copyToClipboard = () => {
    const textToCopy = Object.values(data)
      .map((value) => {
        // Verifica se é um número
        if (typeof value === "number") {
          // Verifica se o número é inteiro
          return Number.isInteger(value)
            ? value.toString() // Mantém inteiros sem formatação adicional
            : value.toFixed(2).replace(".", ","); // Formata números decimais
        }
        return value; // Deixa strings inalteradas
      })
      .join("\n");

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        toast.success('Dados Copiados!');
      })
      .catch((err) => {
        toast.error("Erro ao copiar para o clipboard");
      });
  };

  return (
    <div>
      <Button onClick={copyToClipboard} customColor={color} variant="outlined" disabled={disabled}>
      {text}
      </Button>
    </div>
  );
};

export default ToClipboard;
